import { Typography } from '@euler/app/components/typography';
import { MemberChatButtonByName } from '@euler/app/flows/chat/components/MemberChatButtonByName';
import { kSubjectTypeInfoMap } from '@euler/app/flows/order/pages/ServiceSubjectsScreen/functions/subjectTypeInfoUtil';
import { useServiceRecordContext } from '@euler/app/flows/record/ServiceRecordContext';
import { TaskDetailSection } from '@euler/app/flows/task/pages/detail/components/TaskDetailSection';
import { Center } from '@euler/components/Center';
import { EmptyView } from '@euler/components/EmptyView';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ServiceSubjectType } from '@euler/model/enum';
import { memo } from 'react';
import { StyleProp, TouchableOpacity, View, ViewStyle } from 'react-native';

export const ServiceSubjects = memo(() => {
  const { serviceRecord } = useServiceRecordContext();
  const { rpx } = useResponsiveContext();
  return (
    <TaskDetailSection
      title="服务项目"
      noBodyPadding
      headerStyle={{ borderBottomWidth: 0 }}
      css={`
        margin-bottom: ${rpx(15)}px;
      `}
    >
      {serviceRecord.orderDetail?.serviceSubjects?.length ? (
        serviceRecord.orderDetail.serviceSubjects.map((subject, index) => (
          <Cell
            title={subject.name}
            author={subject.assignedTo?.name ?? ''}
            type={subject.type}
            key={index}
            first={index === 0}
          />
        ))
      ) : serviceRecord.items?.length ? (
        serviceRecord.items?.map((item, index) => (
          <Cell
            title={item.name}
            type={
              item.name === '常规检测'
                ? ServiceSubjectType.Inspection
                : ServiceSubjectType.Construction
            }
            author={item.author ?? ''}
            key={index}
          />
        ))
      ) : (
        <EmptyView
          noFullHeight
          message="本次服务无相关服务项目"
          style={{ paddingBottom: rpx(20) }}
          messageStyle={{
            marginTop: rpx(5),
            fontSize: rpx(11),
            fontFamily: FontFamily.NotoSans.Medium,
          }}
          iconColor="#ccc"
          iconSize={rpx(32)}
        />
      )}
    </TaskDetailSection>
  );
});

const Cell = memo(
  ({
    title,
    type,
    author,
    style,
  }: {
    first?: boolean;
    title: string;
    author: string;
    type?: ServiceSubjectType;
    style?: StyleProp<ViewStyle>;
  }) => {
    const { rpx } = useResponsiveContext();
    const subjectTypeInfo = type
      ? kSubjectTypeInfoMap[type]
      : kSubjectTypeInfoMap[ServiceSubjectType.Other];
    return (
      <TouchableOpacity
        css={`
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          padding: ${rpx(10)}px ${rpx(15)}px;
          border-top-width: 1px;
          border-top-color: #e7e7e7;
        `}
        style={style}
      >
        <View
          css={`
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            flex: 1;
          `}
        >
          <Typography.Label
            regular
            size={rpx(16)}
            css={`
              flex-shrink: 1;
            `}
          >
            {title}
          </Typography.Label>
          {author ? (
            <Typography.Label regular size={rpx(14)} color="#777">
              {` (${author})`}
            </Typography.Label>
          ) : null}
          <MemberChatButtonByName
            name={author}
            size={rpx(16)}
            style={{ marginLeft: rpx(6) }}
          />
        </View>
        <Center
          css={`
            border-radius: ${rpx(3)}px;
            height: ${rpx(20)}px;
            padding: 0 ${rpx(5)}px;
            background-color: ${subjectTypeInfo.bgColor};
            margin-left: ${rpx(5)}px;
          `}
        >
          <Typography.Label
            color={subjectTypeInfo.textColor}
            light
            size={rpx(10)}
            lineHeight={rpx(20)}
          >
            {subjectTypeInfo.text}
          </Typography.Label>
        </Center>
      </TouchableOpacity>
    );
  },
);
